import articlesFile from "./articles.json";

export const SITE_URL = "https://www.zaviramed.com.ng";
export const WHATSAPP_NUMBER = "2348069804062";

const DEFAULT_CATEGORIES = [
  "Women's Health",
  "Sexual Health",
  "General Health",
  "Children",
  "Pregnancy",
];

function absoluteUrl(value, fallback = "/doctor-patient.png") {
  const url = value || fallback;
  return /^https?:\/\//i.test(url) ? url : `${SITE_URL}${url}`;
}

function buildWhatsAppUrl(article) {
  const message =
    article.consultationMessage ||
    `Hello Zaviramed, I would like to speak with a doctor about ${article.shortTitle || article.title}.`;

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

function buildToc(article) {
  if (Array.isArray(article.toc) && article.toc.length) return article.toc;

  return (article.sections || [])
    .filter((section) => section.showInToc !== false)
    .map((section) => ({
      id: section.id,
      label: section.tocLabel || section.title,
    }));
}

function normalizeArticle(article) {
  return {
    ...article,
    url: article.url || `${SITE_URL}/articles/${article.slug}`,
    image: absoluteUrl(article.image),
    whatsappUrl: article.whatsappUrl || buildWhatsAppUrl(article),
    keywords: Array.isArray(article.keywords) ? article.keywords : [],
    sections: Array.isArray(article.sections) ? article.sections : [],
    faqs: Array.isArray(article.faqs) ? article.faqs : [],
    references: Array.isArray(article.references) ? article.references : [],
    relatedArticles: Array.isArray(article.relatedArticles)
      ? article.relatedArticles
      : [],
    toc: buildToc(article),
  };
}

export const articles = (articlesFile.articles || []).map(normalizeArticle);
export const articleDirectory = articles;

export const articleCategories = Array.from(
  new Set([
    ...DEFAULT_CATEGORIES,
    ...articles.map((article) => article.category).filter(Boolean),
  ])
);

export function getArticleBySlug(slug) {
  return articles.find((article) => article.slug === slug);
}

export const vaginalDischargeArticle = getArticleBySlug("vaginal-discharge");
export const utiArticle = getArticleBySlug("urinary-tract-infection");
export const vaginalDischargeWhatsAppUrl =
  vaginalDischargeArticle?.whatsappUrl || buildWhatsAppUrl({});
export const utiWhatsAppUrl = utiArticle?.whatsappUrl || buildWhatsAppUrl({});
export const defaultArticleWhatsAppUrl =
  articles[0]?.whatsappUrl || vaginalDischargeWhatsAppUrl;

export function formatArticleDate(value) {
  return new Intl.DateTimeFormat("en-NG", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(`${value}T00:00:00+01:00`));
}
